import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import warning_icon from "../../assets/images/warning_icon.svg";

function CompanyActivationPopup({
    show,
    handleClose,
    onConfirm,
    title = "Confirm Company Activation",
    message = "Are you sure the company is verified from Kotapay? Otherwise, it could cause issues.",
    isActive = true,
    isLoading = false,
    errorMessage = null
}) {
    const [kotapayCompanyId, setKotapayCompanyId] = useState("");
    const [kotapayPaymentId, setKotapayPaymentId] = useState("");

    useEffect(() => {
        if (!show) {
            setKotapayCompanyId("");
            setKotapayPaymentId("");
        }
    }, [show]);

    const handleConfirmClick = () => {
        if (onConfirm) {
            onConfirm({ kotapayCompanyId, kotapayPaymentId });
        }
    };

    const isFormValid = kotapayCompanyId.trim() !== "";

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="activation_popup"
            aria-labelledby="company-activation-title"
        >
            <Modal.Body className="text-center">
                <img src={warning_icon} alt="Warning" />

                <h4
                    id="company-activation-title"
                    className="fs_20 fw_500 mb-0 mt_10"
                >
                    {title}
                </h4>

                <p className="fs_14 mt_10">{message}</p>

                <div className="common_input_forms">
                    <div className="form_group">
                        <label>Kotapay Company ID</label>
                        <input
                            type="text"
                            className="form-control pl_16"
                            placeholder="Enter Kotapay Company ID"
                            value={kotapayCompanyId}
                            onChange={(e) => setKotapayCompanyId(e.target.value)}
                            autoComplete="off"
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form_group">
                        <label>Kotapay Payment ID</label>
                        <input
                            type="text"
                            className="form-control pl_16"
                            placeholder="Enter Kotapay Payment ID"
                            value={kotapayPaymentId}
                            onChange={(e) => setKotapayPaymentId(e.target.value)}
                            autoComplete="off"
                            disabled={isLoading}
                        />
                    </div>
                </div>

                {errorMessage && (
                    <small className="text-danger d-block mt-2">
                        {errorMessage}
                    </small>
                )}

                <small
                    id="company-activation-help"
                    className="text-muted d-block mt-2"
                >
                    This action will activate the company and enable all related
                    operations.
                </small>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    className="btn_cancel"
                    disabled={isLoading}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleConfirmClick}
                    disabled={!isFormValid || isLoading}
                    className="btn_primary"
                >
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Activating...
                        </>
                    ) : (
                        "Activate"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

CompanyActivationPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    isActive: PropTypes.bool
};

export default CompanyActivationPopup;
